import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import Header from "../../components/header/Header";
import "./home.css";
import _ from "lodash";
import UserService from "../../services/user.service";
import Preloader from "../../components/preloader/Preloader";

const pageSize = 10;

const ReviewerHome = () => {
const [fetching, setFetching] = useState(false);
	const [tableData, setTableData] = useState([]);
	const [paginatedTable, setPaginatedTable] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [searchTerm, setSearchTerm] = useState("");

	const getProjects = async () => {
		setFetching(true);
		let res = await UserService.getAllProject();
		const data = res.project;
		setTableData(data);
		setPaginatedTable(_(data).slice(0).take(pageSize).value());
		setFetching(false);
	};

	useEffect(() => {
		getProjects();
	}, []);

	const checkProjectStage = (r, a) => {
		if (r === false && a === false) {
			return "PENDING REVIEW";
		} else if (r === true && a === false) {
			return "PENDING APPROVAL";
		} else if (r === true && a === true) {
			return "APPROVED";
		} else {
			return "PENDING REVIEW";
		}
	};

	const splitMoneyByCommas = (num) => {
		return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	};

	const pageCount = tableData ? Math.ceil(tableData.length / pageSize) : 0;

	const pages = _.range(1, pageCount + 1);

	const handlePagination = (pageNum) => {
		setCurrentPage(pageNum);
		const startIndex = (pageNum - 1) * pageSize;
		const paginatedTableData = _(tableData)
			.slice(startIndex)
			.take(pageSize)
			.value();
		setPaginatedTable(paginatedTableData);
	};

	return (
		<div className="request__page__wrapper">
			<Header />
			<div className="request__page">
				<div className="review__desk__heading">REVIEW DESK</div>

				{/* <!-- DataTales Example --> */}
				<div className="request-page__card">
					<div className="card-header">
						<Form.Select
							size="lg"
							className="request__page__input"
							onChange={(e) => setSearchTerm(e.target.value)}
						>
							<option value="">ALL ENTRIES</option>
							<option value="PENDING APPROVAL">PENDING APPROVAL</option>
							<option value="PENDING REVIEW">PENDING REVIEW</option>
							<option value="APPROVED">APPROVED</option>
						</Form.Select>
						<Form.Control
							size="lg"
							className="request__page__input"
							type="text"
							placeholder="SEARCH..."
							onChange={(e) => setSearchTerm(e.target.value)}
						/>
					</div>
					<div className="card-body">
						{paginatedTable.length === 0 ? (
							<div>No entries yet</div>
						) : (
							<div className="table-responsive">
								<table
									className="table bordered border"
									id="dataTable"
									width="100%"
									cellspacing="0"
								>
									{/* <thead></thead> */}
									<tbody>
										<tr className="thead">
											<th className="request__table__head">S/NO</th>
											<th className="request__table__head">PROJECT TITLE</th>
											<th className="request__table__head">PURPOSE OF PROJECT</th>
											<th className="request__table__head">PROJECT LOCATION</th>
											<th className="request__table__head">PROJECT AMOUNT</th>
											<th className="request__table__head">PROJECT CONTRACTOR</th>
											<th className="request__table__head">PROJECT STAGE</th>
										</tr>
										{paginatedTable
											.filter((val) => {
												if (searchTerm === "") {
													return val;
												}
												if (
													val.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
													val.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
													val.purpose.toLowerCase().includes(searchTerm.toLowerCase()) ||
													val.companyName.toLowerCase().includes(searchTerm.toLowerCase())
												) {
													return val;
												}
												if (
													checkProjectStage(val.reviewed, val.approved)
														.toLocaleLowerCase()
														.includes(searchTerm.toLowerCase())
												) {
													return val;
												}
												return false;
											})
											.map((item, i) => (
												<tr
													onClick={() =>
														(window.location.href = `/reviewer/desk/${item._id}`)
													}
													key={item._id}
													className="table-row__link"
												>
													<td>{i + 1}.</td>
													<td className="request__body request__project__title">
														{item.title.toUpperCase()}
													</td>
													<td className="request__body request__body-item">
														{item.purpose.toUpperCase()}
													</td>
													<td className="request__body request__body-item">
														{item.location.toUpperCase()}
													</td>
													<td className="request__body request__body-item">
														&#x20A6; {splitMoneyByCommas(item.fullAmount)}
													</td>
													<td className="request__body request__body-item">
														{item.companyName.toUpperCase()}
													</td>
													<td className="request__body request__body-item">
														{checkProjectStage(item.reviewed, item.approved)}
													</td>
												</tr>
											))}
									</tbody>
								</table>
							</div>
						)}
					</div>
				</div>
				<nav className="d-flex justify-content-center">
					<ul className="pagination">
						{pages.map((page, idx) => (
							<li
								key={idx}
								className={page === currentPage ? "page-item active" : "page-item"}
							>
								<p className="page-link" onClick={() => handlePagination(page)}>
									{page}
								</p>
							</li>
						))}
					</ul>
				</nav>
			</div>
			{fetching && <Preloader text={"Fetching data"} />}
		</div>
	);
};

export default ReviewerHome;
